var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAckodriveBuyCar = function SvgAckodriveBuyCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#36354C",
    fillRule: "evenodd",
    d: "M14.615 15.908H8.907v-1.539h5.708z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#36354C",
    fillRule: "evenodd",
    d: "M16.508 14.01a1.125 1.125 0 1 0 0 2.252 1.125 1.125 0 0 0 0-2.251m-2.664 1.126a2.664 2.664 0 1 1 5.328 0 2.664 2.664 0 0 1-5.328 0M7.014 13.975a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25M4.35 15.1a2.664 2.664 0 1 1 5.328 0 2.664 2.664 0 0 1-5.328 0",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#36354C",
    fillRule: "evenodd",
    d: "M13.19 7.96a2.8 2.8 0 0 0-1.09-.222H8.564a1.74 1.74 0 0 0-1.427.742l-.002.002-1.424 2.014a2.15 2.15 0 0 1-1.23.843l-.005.002-.698.166a.313.313 0 0 0-.238.34v.005l.235 2.277a.28.28 0 0 0 .273.238h.74v1.538h-.744a1.816 1.816 0 0 1-1.797-1.592v-.008l-.236-2.287a1.85 1.85 0 0 1 1.41-2.008l.689-.163c.139-.036.26-.12.343-.238l1.424-2.012A3.28 3.28 0 0 1 8.568 6.2h3.528a4.3 4.3 0 0 1 3.123 1.333l.002.001 2.181 2.312 2.741.497h.001a2.264 2.264 0 0 1 1.785 2.79l-.282 1.176-.002.006a2.146 2.146 0 0 1-2.089 1.614h-1.245v-1.538h1.252a.61.61 0 0 0 .59-.453l.283-1.178.002-.007a.725.725 0 0 0-.57-.896h-.001l-3.237-.587-2.524-2.676-.002-.001a2.8 2.8 0 0 0-.913-.633",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#36354C",
    fillRule: "evenodd",
    d: "m4.64 9.708 12.392.094-.012 1.539-12.392-.095z",
    clipRule: "evenodd"
  })));
};
export default SvgAckodriveBuyCar;